// ----------------------------------------------------------------------
// <copyright file="Izenda.CodeMirrorExt.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var CodeMirror = require('codemirror');
  require('codemirror/mode/htmlmixed/htmlmixed');
  require('codemirror/addon/search/search');
  require('codemirror/addon/search/searchcursor');

  var lastPos = null;
  var lastQuery = null;
  var marked = [];

  function unmark() {
    for (var i = 0; i < marked.length; ++i) {
      marked[i].clear();
    }
    marked = [];
  }

  CodeMirror.extendMode("xml", {
    commentStart: "<!--",
    commentEnd: "-->",
    newlineAfterToken: function(type, content, textAfter) {
      return type == "tag" && />$/.test(content) || /^</.test(textAfter);
    }
  });

  // CodeMirror autoFormat extension, inserts newlines and identation according to settings
  // formats a range given from: {line, ch}, to: {line, ch}
  CodeMirror.defineExtension("autoFormatRange", function(from, to) {
    var cm = this;
    var outer = cm.getMode(),
      text = cm.getRange(from, to).split("\n");
    var state = CodeMirror.copyState(outer, cm.getTokenAt(from).state);
    var tabSize = cm.getOption("tabSize");

    var out = "",
      lines = 0,
      atSol = from.ch === 0;

    function newline() {
      out += "\n";
      atSol = true;
      ++lines;
    }

    for (var i = 0; i < text.length; ++i) {
      var stream = new CodeMirror.StringStream(text[i], tabSize);
      while (!stream.eol()) {
        var inner = CodeMirror.innerMode(outer, state);
        var style = outer.token(stream, state),
          cur = stream.current();
        stream.start = stream.pos;
        if (!atSol || /\S/.test(cur)) {
          out += cur;
          atSol = false;
        }
        if (!atSol && inner.mode.newlineAfterToken &&
          inner.mode.newlineAfterToken(style, cur, stream.string.slice(stream.pos) || text[i + 1] || "", inner.state)) {
          newline();
        }
      }
      if (!stream.pos && outer.blankLine) { outer.blankLine(state); }
      if (!atSol) { newline(); }
    }

    cm.operation(function() {
      cm.replaceRange(out, from, to);
      for (var cur = from.line + 1, end = from.line + lines; cur <= end; ++cur) {
        cm.indentLine(cur, "smart");
      }
    });
  });

  // Gets full content range for given CodeMirror editor
  // @return Range object {from: {line, ch}, to: {line, ch}}
  CodeMirror.defineExtension("getFullRange", function() {
    var cm = this;
    var from, to;
    from = { line: 0, ch: 0 };
    to = cm.posFromIndex(cm.getValue().length);
    return {
      from: from,
      to: to
    };
  });

  // Extension to use autoFormatRange for the whole document
  CodeMirror.defineExtension("autoFormatAll", function() {
    var cm = this;
    var range = cm.getFullRange();
    cm.autoFormatRange(range.from, range.to);
  });

  CodeMirror.defineExtension("searchCode", function(text) {
    const cm = this;
    unmark();

    if (!cm.getSearchCursor(text).findNext()) {
      return false;
    }

    for (let cursor = cm.getSearchCursor(text); cursor.findNext();) {
      marked.push(cm.markText(cursor.from(), cursor.to(), "searched"));
    }

    if (lastQuery != text) {
      lastPos = null;
    }

    let cursor = cm.getSearchCursor(text, lastPos || cm.getCursor());
    if (!cursor.findNext()) {
      cursor = cm.getSearchCursor(text);
      if (!cursor.findNext()) {
        return;
      }
    }

    cm.setSelection(cursor.from(), cursor.to());
    lastQuery = text;
    lastPos = cursor.to();
  });

  CodeMirror.defineExtension("replaceCode", function(text, replace) {
    var cm = this;
    unmark();

    if(!cm.getSearchCursor(text).findNext()) {
      return false;
    }

    for (var cursor = cm.getSearchCursor(text); cursor.findNext();) {
      cm.replaceRange(replace, cursor.from(), cursor.to());
    }
  });

  module.exports = CodeMirror;
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/CodeMirror/Izenda.CodeMirrorExt.js